import React from "react";

import { useUderlyStore } from '@uderly/react-uderly-ui/zustand';

const withUderlyStore = BaseComponent => props => {
  const store = useUderlyStore();
  return <BaseComponent {...props} zustand={store} />;
};

export default withUderlyStore;